import type { PropsWithChildren } from "react";
import { ChakraProvider } from "@chakra-ui/react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import { system } from "./system";

export function ThemeProvider({ children }: PropsWithChildren) {
  return (
    <ChakraProvider value={system}>
      <NextThemesProvider attribute="class" defaultTheme="dark" enableSystem disableTransitionOnChange>
        {children}
      </NextThemesProvider>
    </ChakraProvider>
  );
}
